import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

export const FETCH_DEPSEARCH_BEGIN = "FETCH_DEPSEARCH_BEGIN"
export const FETCH_DEPSEARCH_SUCCESS = "FETCH_DEPSEARCH_SUCCESS"
export const FETCH_DEPSEARCH_ERROR = "FETCH_DEPSEARCH_ERROR"
export const FETCH_DEPSEARCH_FULLRESET = "FETCH_DEPSEARCH_FULLRESET"
export const SET_DEPSEARCH_CRITERES = "SET_DEPSEARCH_CRITERES"

export const fetchDepSearchBegin = () => ({
	type: FETCH_DEPSEARCH_BEGIN,
})

export const fetchDepSearchSuccess = (deps) => ({
	type: FETCH_DEPSEARCH_SUCCESS,
	payload: { deps },
})

export const fetchDepSearchError = (error) => ({
	type: FETCH_DEPSEARCH_ERROR,
	payload: { error },
})

export function fetchDepSearch(kwargs) {
	// Querystring encodée (accents/espaces/& dans nom/plaques ne cassent plus
	// l'URL). Remplace l'ancienne concat brute (+ un substr mort qui laissait un
	// « & » final).
	const qs = Object.entries(kwargs)
		.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
		.join("&")
	const url = `${URL}api/depannages?${qs}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchDepSearchBegin())
		// Retourne le json au thunk appelant (patron V2 : le composant form
		// navigue vers /depannage/resultats si json est présent — undefined sur
		// erreur, car catchApiError résout sans valeur).
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchDepSearchSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, fetchDepSearchError))
	}
}

export const fetchDepSearchFullReset = () => ({
	type: FETCH_DEPSEARCH_FULLRESET,
})

// Mémorise les critères de la dernière recherche (préremplissage du form +
// re-recherche après suppression). Calqué sur setAtelierSearchCriteres.
export const setDepSearchCriteres = (criteres) => ({
	type: SET_DEPSEARCH_CRITERES,
	payload: { criteres },
})

// DELETE_DEPANNAGE

export const DELETE_DEPANNAGE_BEGIN = "DELETE_DEPANNAGE_BEGIN"
export const DELETE_DEPANNAGE_SUCCESS = "DELETE_DEPANNAGE_SUCCESS"
export const DELETE_DEPANNAGE_ERROR = "DELETE_DEPANNAGE_ERROR"
export const DELETE_DEPANNAGE_RESET = "DELETE_DEPANNAGE_RESET"

export const deleteDepannageBegin = (ticket) => ({
	type: DELETE_DEPANNAGE_BEGIN,
	payload: { ticket },
})

export const deleteDepannageSuccess = (deps, id, ticket) => ({
	type: DELETE_DEPANNAGE_SUCCESS,
	payload: { deps, id, ticket },
})

export const deleteDepannageError = (error, ticket) => ({
	type: DELETE_DEPANNAGE_ERROR,
	payload: { error, ticket },
})

export const deleteDepannageReset = () => ({
	type: DELETE_DEPANNAGE_RESET,
})

// Ticket de chaque suppression : une réponse arrivée après un RESET (page
// quittée en pleine suppression, autre fiche ouverte depuis) ne s'affiche
// pas dans le modal d'une autre fiche — seule la ligne supprimée quitte la
// liste (reducer).
let ticketSuppression = 0

// silent : l'erreur s'affiche dans ResultDeleteModal (règle hybride).
// `data` = { id, search, orderBy } : le DELETE relance la recherche mais ne
// renvoie que les dépannages — l'id permet au reducer de purger les livs.
export function deleteDepannage(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		const ticket = ++ticketSuppression
		dispatch(deleteDepannageBegin(ticket))
		return fetch(`${URL}api/depannages`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) =>
				dispatch(deleteDepannageSuccess(json, data.id, ticket)),
			)
			.catch(
				catchApiError(
					dispatch,
					(error) => deleteDepannageError(error, ticket),
					{ silent: true },
				),
			)
	}
}
